import { render, staticRenderFns } from "./Homehead.vue?vue&type=template&id=4b4c53ec&scoped=true&"
import script from "./Homehead.vue?vue&type=script&lang=js&"
export * from "./Homehead.vue?vue&type=script&lang=js&"
import style0 from "./Homehead.vue?vue&type=style&index=0&id=4b4c53ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4c53ec",
  null
  
)

export default component.exports